import _ from 'lodash';
import { Record } from 'immutable';
import PhotoHash from './PhotoHash';
import indefiniteArticle from '../lib/indefiniteArticle';
import config from '../config/client';

const StoreDefaults = {
  id: null,
  name: null,
  marketing_message: null,
  editorial_text: null,
  avatar_photo_hash: null,
  logo_photo_hash: null,
  screensaver_photo_hash: null,
  background_photo_hash: null,
  kiosk_code: null,
  location: null,
  min_price_in_cents: null,
  max_price_in_cents: null,
  policy_url: null,
  about_url: null,
  contact_email: null,
  phone_pretty: null,
  phone_href_format: null,
  description: null,
  // customer_context: null,
  address: null,
  hours: null,
  banner: null,
  slug: null,
  domain: null,
  referral_link_url: null,
  navigation: [],
  refund_policy: '',
  terms_of_service: ''
};

class Store extends Record(StoreDefaults) {
  constructor(values) {
    values.avatar_photo_hash = (values.avatar_photo_hash instanceof PhotoHash) ? values.avatar_photo_hash : new PhotoHash(values.avatar_photo_hash);
    values.logo_photo_hash = (values.logo_photo_hash instanceof PhotoHash) ? values.logo_photo_hash : new PhotoHash(values.logo_photo_hash);
    if (values.screensaver_photo_hash != null) {
      values.screensaver_photo_hash = (values.screensaver_photo_hash instanceof PhotoHash) ? values.screensaver_photo_hash : new PhotoHash(values.screensaver_photo_hash);
    }
    values.background_photo_hash = (values.background_photo_hash instanceof PhotoHash) ? values.background_photo_hash : new PhotoHash(values.background_photo_hash);
    // NOTE: `customer_context` is not currently being used
    // values.customer_context = (values.customer_context instanceof CustomerContext) ? values.customer_context : new CustomerContext(values.customer_context);

    super(values);
  }

  get root_path() {
    if(this.domain) {
      return `/`;
    }
    return `/${this.slug}`;
  }

  get url() {
    if(this.domain) {
      return 'https://' + this.domain + this.root_path; //Hard-coding the protocol... not ideal
    }
    return config.BanquetUrl + this.root_path;
  }

  metaTagDescription() {
    return this.description || this.marketing_message || 'Pick up in-store or have wines delivered to your door.';
  }

  metaTagTitle() {
    return `${this.name} – ${indefiniteArticle(this.location)} ${this.location} shop`;
  }

  findTitleForCategoryURL(url) {
    if(!this.navigation || !this.navigation.length) {return null;}
    let match = null;
    let configs = _.cloneDeep(this.navigation);
    while(!match && configs.length) {
      let config = configs.shift();
      if(config.url === url) {
        match = config;
      } else if(config.children && config.children.length) {
        config.children.forEach((child) => {
          configs.push(child);
        });
      }
    }
    return match;
  }
}

export default Store;

const CustomerContextDefaults = {
  favorited: false,
  same_day_delivery: false,
  items_in_shopping_cart: 0,
  editorial_text: null
};

class CustomerContext extends Record(CustomerContextDefaults) {}



// WEBPACK FOOTER //
// banquet/models/Store.js